import { render, staticRenderFns } from "./Form22Layout.vue?vue&type=template&id=623def78&scoped=true"
import script from "./Form22Layout.vue?vue&type=script&lang=ts"
export * from "./Form22Layout.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=623def78&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623def78",
  null
  
)

export default component.exports